export const environment = {
  appName: import.meta.env.VITE_APP_NAME || "Orbit",
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "/api/v1",
  uploadBaseUrl: import.meta.env.VITE_UPLOAD_BASE_URL || "/uploads",
  profileImageBaseUrl: `${import.meta.env.VITE_UPLOAD_BASE_URL || "/uploads"}/profile-images`,
  propertyImageBaseUrl: `${import.meta.env.VITE_UPLOAD_BASE_URL || "/uploads"}/properties`,
  requestTimeoutMs: 20_000,
} as const;
